import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Axios from 'axios'

import VueFormWizard from 'vue-form-wizard'
import Vuelidate from 'vuelidate'
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm'
import VueTabs from 'vue-nav-tabs/dist/vue-tabs'
import * as VueGoogleMaps from 'vue2-google-maps'
import VCalendar from 'v-calendar';
import Tawk from 'vue-tawk';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faFacebookF } from '@fortawesome/free-brands-svg-icons'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { faInfo }  from '@fortawesome/free-solid-svg-icons'
import { faStar }  from '@fortawesome/free-solid-svg-icons'
import { faCircle }  from '@fortawesome/free-solid-svg-icons'
import { faChevronLeft }  from '@fortawesome/free-solid-svg-icons'
import { faChevronRight }  from '@fortawesome/free-solid-svg-icons'
import { faPlus }  from '@fortawesome/free-solid-svg-icons'
import { faCamera }  from '@fortawesome/free-solid-svg-icons'
import { faBars }  from '@fortawesome/free-solid-svg-icons'
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import { faTwitter } from '@fortawesome/free-brands-svg-icons'
import { faCopy }  from '@fortawesome/free-solid-svg-icons'
import { faArrowAltCircleDown }  from '@fortawesome/free-solid-svg-icons'


import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue-nav-tabs/themes/vue-tabs.css'
import './assets/styles.css';
import 'v-calendar/lib/v-calendar.min.css';



library.add (faFacebookF);
library.add (faCheck);
library.add (faTimes);
library.add (faInfo);
library.add (faStar);
library.add (faCircle);
library.add (faChevronLeft);
library.add (faChevronRight);
library.add (faPlus);
library.add (faCamera);
library.add (faBars);
library.add (faWhatsapp);
library.add (faTwitter);
library.add (faCopy);
library.add (faArrowAltCircleDown);

Vue.use(BootstrapVue);
Vue.use(VueFormWizard);
Vue.use(Vuelidate);
Vue.use(VueTabs)
Vue.use(Tawk, {
  tawkSrc: 'https://embed.tawk.to/5a58f9c44b401e45400c0c24/default'  
})


Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCevwnAx6XUOYAwNnp8BXcvg8FPj2nXqMQ',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true
})

Vue.use(VCalendar, {
  firstDayOfWeek: 2,  // Monday
});

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.prototype.$http = Axios;

const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
